module.exports = __webpack_public_path__ + "static/media/std-header-image.27d44fde.jpg";